import { useQuery } from 'react-query';
import { TeamAPI } from 'api/admin/team';
import { TEAMS } from 'helpers/constants';

export default function useTeams() {
  return useQuery(TEAMS, TeamAPI.getAll);
}
